import { CollapsibleSection } from "./CollapsibleSection.js";
import { ProviderPanel } from "./ProviderPanel.js";
import type { ProviderPanelData } from "./ProviderPanel.js";

export interface AdvancedForensicsProps {
  confidenceFactors?: ProviderPanelData | null;
  analysisStatus?: string;
  meta: { source: string; latencyMs: number; cached: boolean };
  cachedAt?: string;
}

export function AdvancedForensics({ confidenceFactors, analysisStatus, meta, cachedAt }: AdvancedForensicsProps) {
  return (
    <CollapsibleSection title="Advanced Forensics">
      <ProviderPanel data={confidenceFactors ?? null} />

      {analysisStatus && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: analysisStatus === 'COMPLETE' ? 'rgba(34,197,94,0.08)' : 'rgba(234,179,8,0.08)', borderRadius: '8px', marginTop: '0.5rem', fontSize: '0.8rem' }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: analysisStatus === 'COMPLETE' ? '#22c55e' : '#eab308', display: 'inline-block' }} />
          <span style={{ color: 'var(--text-secondary)' }}>
            Analysis: <strong>{analysisStatus}</strong>
            {analysisStatus === 'COMPLETE' ? ' \u2014 All intelligence modules processed' : ' \u2014 Deep analysis in progress...'}
          </span>
        </div>
      )}

      <footer className="intel-meta-footer">
        <span>
          Source: {meta.source} &middot; Latency: {meta.latencyMs}ms
          {meta.cached && " (cached)"}
        </span>
        {cachedAt && (
          <span>
            Last updated: {new Date(cachedAt).toLocaleString()}
          </span>
        )}
      </footer>
    </CollapsibleSection>
  );
}
